/**
 * PupCruisers Club — Pack Partners attribution
 * URL ?pp= / ?pp_code= / ?ref= + optional ?pp_click=
 * → cookies pp_code, pp_click (30d)
 * → cart attributes pp_code, pp_click_id (order note_attributes)
 */
(function () {
  "use strict";

  var COOKIE_DAYS = 30;
  var CODE_KEYS = ["pp", "pp_code", "ref"];
  var CLICK_KEYS = ["pp_click", "pp_click_id", "click_id"];
  var TRACK_BASE = "https://pupcruisers.club"; // Member host for /api/pp/track

  function readQuery() {
    var q = {};
    try {
      new URLSearchParams(window.location.search).forEach(function (v, k) {
        q[k.toLowerCase()] = v;
      });
    } catch (e) {}
    return q;
  }

  function firstParam(q, keys) {
    for (var i = 0; i < keys.length; i++) {
      var v = q[keys[i]];
      if (v && String(v).trim()) return String(v).trim();
    }
    return null;
  }

  function setCookie(name, value, days) {
    if (!value) return;
    document.cookie =
      name +
      "=" +
      encodeURIComponent(value) +
      "; path=/; max-age=" +
      days * 86400 +
      "; SameSite=Lax" +
      (location.protocol === "https:" ? "; Secure" : "");
  }

  function getCookie(name) {
    var m = document.cookie.match(
      new RegExp(
        "(?:^|; )" +
          name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") +
          "=([^;]*)"
      )
    );
    return m ? decodeURIComponent(m[1]) : null;
  }

  function sanitizeCode(code) {
    if (!code) return null;
    var s = String(code).trim().slice(0, 64);
    if (!/^[A-Za-z0-9][A-Za-z0-9_-]*$/.test(s)) return null;
    return s;
  }

  function sanitizeClickId(id) {
    if (!id) return null;
    var s = String(id).trim().slice(0, 128);
    if (!/^[A-Za-z0-9][A-Za-z0-9_-]*$/.test(s)) return null;
    return s;
  }

  function resolveAttribution() {
    var q = readQuery();
    var fromUrlCode = sanitizeCode(firstParam(q, CODE_KEYS));
    var fromUrlClick = sanitizeClickId(firstParam(q, CLICK_KEYS));
    if (fromUrlCode) setCookie("pp_code", fromUrlCode, COOKIE_DAYS);
    if (fromUrlClick) setCookie("pp_click", fromUrlClick, COOKIE_DAYS);
    return {
      code: fromUrlCode || sanitizeCode(getCookie("pp_code")),
      clickId: fromUrlClick || sanitizeClickId(getCookie("pp_click")),
      fromUrl: !!(fromUrlCode || fromUrlClick),
    };
  }

  function updateCartAttributes(code, clickId) {
    if (!code && !clickId) return Promise.resolve(null);
    var attributes = {};
    if (code) {
      attributes.pp_code = code;
      attributes.pp = code;
    }
    if (clickId) attributes.pp_click_id = clickId;
    return fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      credentials: "same-origin",
      body: JSON.stringify({ attributes: attributes }),
    }).then(function (res) {
      if (!res.ok) {
        console.warn("[pc-pp] cart/update.js", res.status);
        return null;
      }
      return res.json();
    });
  }

  function sameAsCart(cart, code, clickId) {
    if (!cart || !cart.attributes) return false;
    var a = cart.attributes;
    return (
      (!code || a.pp_code === code || a.pp === code) &&
      (!clickId || a.pp_click_id === clickId)
    );
  }

  function trackClick(code) {
    if (!code) return;
    try {
      fetch(TRACK_BASE.replace(/\/$/, "") + "/api/pp/track", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "omit",
        body: JSON.stringify({
          pp: code,
          pp_code: code,
          store: "shopify_club",
          landing_url: location.href,
        }),
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (data) {
          var clickId = (data && data.click_id) || "";
          if (clickId) {
            setCookie("pp_click", clickId, COOKIE_DAYS);
            updateCartAttributes(code, clickId);
          }
        })
        .catch(function () {});
    } catch (e) {}
  }

  function run() {
    var attr = resolveAttribution();
    if (!attr.code && !attr.clickId) return;

    if (attr.fromUrl && attr.code) trackClick(attr.code);

    var shouldForce = attr.fromUrl;
    fetch("/cart.js", {
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (cart) {
        if (!shouldForce && sameAsCart(cart, attr.code, attr.clickId)) {
          return null;
        }
        return updateCartAttributes(attr.code, attr.clickId);
      })
      .catch(function (err) {
        console.warn("[pc-pp]", err);
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
  document.addEventListener("shopify:section:load", run);
})();